import { render, staticRenderFns } from "./HomeToc.vue?vue&type=template&id=0475c421"
import script from "./HomeToc.vue?vue&type=script&lang=js"
export * from "./HomeToc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports